import { Lci3Report } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { CustomFields } from '../../../components/LciReportSetupForm';
import { Campaign, UseCalculatedFieldsReturn } from '@features/campaigns';
import { Presentation } from '@features/powerpoint';
import { ImageWithMetadata } from '@features/powerpoint';
import { titleSlide } from '../../../slides';
import { appendixSlidesFromProps } from '../slides/appendix/config';
import { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { campaignAnalyticsSlides } from '../slides/campaign-analytics/build-campaign-analytics-slides';
import { visitAttributionSlides } from '../slides/visit-attribution/build-visit-attribution-slides';
import { overviewSlideFromProps } from './build-overview-slide';
import { executiveSummarySlideFromProps } from './build-executive-summary-slide';
import { createSharedPresentationConfig } from '../../../utils/shared-presentation-config';
import { Lci3DimensionTableData } from '@features/lci-report/models/lci3-types';
import { salesAttributionSlides } from '../slides/sales-attribution/build-rsa-slides';
import { Subdimension } from '@features/reports/subdomains/visitation';

export type BuildPresentationProps = {
  campaign: Pick<Campaign, 'id' | 'name' | 'startDate' | 'endDate'>;
  selectedReportDate: Campaign['reportDates'][number];
  brandLogo: ImageWithMetadata | null;
  customFields: CustomFields;
  salesSummary: Lci3Report['salesMetrics'] | null;
  visitMetrics: Lci3Report['visitMetrics'];
  subdimensions: Subdimension[];
  dimensionTableData: Lci3DimensionTableData;
  campaignAnalyticsReport: CampaignAnalyticsReport | null;
  calculatedFields: UseCalculatedFieldsReturn['data'];
};

export const buildPresentation = (
  props: BuildPresentationProps
): Presentation => {
  const sharedConfig = createSharedPresentationConfig({
    campaign: props.campaign,
    brandLogo: props.brandLogo,
  });

  return {
    ...sharedConfig,
    filename: `${props.campaign.name}_lci_report_${props.selectedReportDate}.pptx`,
    slides: [
      titleSlide({
        id: props.campaign.id,
        name: props.campaign.name,
      }),
      ...overviewSlideFromProps(props, sharedConfig.slideMasters[0].title),
      ...executiveSummarySlideFromProps(
        props,
        sharedConfig.slideMasters[0].title
      ),
      ...visitAttributionSlides(props, sharedConfig.slideMasters[0].title),
      ...salesAttributionSlides(props, sharedConfig.slideMasters[0].title),
      ...campaignAnalyticsSlides(props, sharedConfig.slideMasters[0].title),
      ...appendixSlidesFromProps(props),
    ],
  };
};
